// extracted by mini-css-extract-plugin
export default {"blogsPage":"blogsPage_blogsPage__65tVb","wrapper":"blogsPage_wrapper__Svkis","main":"blogsPage_main__0pewQ","aside":"blogsPage_aside__dNGYr"};